import React, { useState } from "react"
import { MileageForm } from "@/components/forms/MileageForm"
import { OnboardingLayout } from "@/components/layouts/OnboardingLayout"
import { useForm } from "react-hook-form"
import { RHFProvider } from "@/components/forms/RHFProvider"
import { MileageFormData } from "@/state/draft/mileage"
import { Dialog } from "@/components/ui/dialog"
import { TermsDialogContent } from "./TermsDialogScreen"
import { useAnalytics } from "@/hooks/use-analytics"
import { PlainDate } from "@/utils/date"

type OnboardingMileageScreenProps = {
	onSubmit: (data: MileageFormData) => void
	onBack: () => void
	value: MileageFormData
	dateRange: [PlainDate, PlainDate]
	onTermsAccept: () => void
	termsAccepted: boolean
}

export const OnboardingMileageScreen: React.FC<OnboardingMileageScreenProps> = (
	props
) => {
	const analytics = useAnalytics("Create_Terms")

	const form = useForm<MileageFormData>({
		defaultValues: props.value,
	})
	const [termsVisible, setTermsVisible] = useState(false)

	return (
		<OnboardingLayout
			stepper={{
				currentStep: 4,
				steps: 4,
			}}
			title="Business Miles for Deduction"
			onNext={() => {
				form.handleSubmit((data) => {
					if (props.termsAccepted) {
						props.onSubmit(form.getValues())
						return
					}

					analytics.sendEvent("Step_Terms__View")
					setTermsVisible(true)
				})()
			}}
			onBack={props.onBack}
			continueText="Generate Report"
		>
			<RHFProvider form={form}>
				<Dialog open={termsVisible} onOpenChange={setTermsVisible}>
					<TermsDialogContent
						onAccept={() => {
							analytics.sendEvent("Step_Terms__Continue")
							setTermsVisible(false)
							props.onTermsAccept()
							props.onSubmit(form.getValues())
						}}
					/>
				</Dialog>
				<MileageForm
					dateRange={props.dateRange}
					form={form}
					advancedFormEnabled={false}
				/>
			</RHFProvider>
		</OnboardingLayout>
	)
}
